export default ({signInUrl, supportText}) => `
<div class="modal-container" >
    <p > ${ html('reauthenticateModal.signInAgain') } </p>

    <p> ${supportText} </p>

    <div class="button-container">
        <a href="${ signInUrl }" role="button" class="button primary margin-small radius u-allCaps" aria-label="${ html('signIn') }">
            ${ html('signIn') }
        </a>
        <button type="button" class="button radius margin-small secondary cancel u-allCaps">${ html('cancel') }</button>
    </div>
</div>
`;
